// Module
var code = `<custom-fee-list ng-if="\$ctrl.deposit" form="\$ctrl.form"
                 fee-definitions="\$ctrl.feeDefinitions"
                 product-group="'DEPOSIT'"
                 on-change="\$ctrl.onSave()">
</custom-fee-list>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/term-deposit/section/term-deposit-fees.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;